import type { GetColumnSuggestionsRequest, MapDataResponse } from '../listMatching/dto';

export interface MapDataConsentResponse extends MapDataResponse {
  consentWorkflow: boolean;
  dataPreview: Record<string, unknown>[];
  purgedFiles: string[];
  warning?: boolean;
  warningDesc?: string;
}
export const SOFT_MATCH_ATTRIBUTES_SOURCE = 'npi-list';

export interface GetColumnSuggestionsConsentRequest extends GetColumnSuggestionsRequest {
  source?: string;
}

export interface GetAvailableAttributesConsentRequest {
  source?: string;
  workspaceID?: number;
}

export interface SoftMatchFilters {
  sourceNpiList: string;
  businessUnit: string;
  businessVertical: string;
  product: string;
  pharma: string;
  brands: string[];
  states: string[];
}

export interface SoftMatchProcessRequest {
  npiListId: number;
  workspaceID: number;
  countriesAllowed: string[];
  statesSuppression: string[];
  updatedBy?: string;
}

export interface SoftMatchDedup {
  rowsTotal: number;
  rowsKept: number;
  rowsDropped: number;
}

export interface SoftMatchEmailSuppressionStats {
  rows_state_suppressed: number;
  rows_state_suppressed_zip_file: number;
  rows_state_suppressed_licensed: number;
  rows_state_suppressed_both: number;
  rows_dashboard_eligible: number;
  rows_no_valid_email_row: number;
  rows_opt_out_suppressed: number;
  emailDeprioritizationRuleDomains: number;
}

export interface RegistrationTypeBackfill {
  field: string;
  source: string;
  row_count: number;
  rows_from_profile: number;
  rows_backfilled: number;
  placeholder_value: string;
  what_happened: string;
}

export interface SoftMatchProcessResponse {
  eventID?: string | null;
  npiListId: number;
  sourceBlobPath: string;
  destinationBlobPath: string;
  copied: boolean;
  reservationID?: string | null;
  rowsTotal: number;
  rowsDeduped: number;
  softMatchDedup: SoftMatchDedup;
  rowsMatched: number;
  rowsUnmatched: number;
  matchTypeCounts: Record<string, number>;
  registrationTypeBackfill?: RegistrationTypeBackfill | null;
  softMatchEmailSuppressionStats?: SoftMatchEmailSuppressionStats | null;
  purgedFiles?: string[] | null;
}

export interface SoftMatchState {
  filters: SoftMatchFilters;
}
